export default null;

export const LIMIT_TIME = 10 * 60 * 1000; // 10분 (10 * 60000)

export const INIT_PRO_APPLY = {
	centerId: null,
	region: '', // 추후 region, state 삭제 예정
	state: '',
	sidoCode: '',
	sidoName: '',
	sigunguCode: '',
	sigunguName: '',
	buildingCode: '',
	postalCode: '',
	roadPart: '',
	detailPart: '',
	wishPrice: '', // 딜러 바로 매입 - 판매 희망가
	sellerName: '',
	sellerPhoneNumber: '',
	ownerPhoneNumber: '',
	isSameAsApplicant: false,
	phoneCertificationInfo: '',
	code: '',
	date: '',
	time: '',
	codeExpireTime: '',
	isPhoneCertificatied: false,
	agrees: {
		all: false,
		terms: false,
		privacy: false,
		thirdParties: false,
		marketing: false, // legacy의 serviceIntroduce와 매칭
		electronicMedia: false,
	},
	availableDateTimeList: [],
	viewBanner: false,
	isSameAddress: true,
	inputCurrentTime: '',
	inputEndTime: '',
	isShowHolidayLayer: false,
	isReserve: false, // 비교견적 프로 예약 변경 플래그
};
